import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    urlLogo: "",
    urlLogoFechada: "",
    urlLogoAberta: ""
};

const imagesSlice = createSlice({
    name: "images",
    initialState,
    reducers: {
        setImages: (state, action) => {
            state.urlLogo = action.payload.Content.UrlLogoFull;
            state.urlLogoAberta = action.payload.Content.UrlLogoAberta;
            state.urlLogoFechada = action.payload.Content.UrlLogoFechada;
        }
    }
});

export const { setImages } = imagesSlice.actions;
export default imagesSlice.reducer;